import { ServiceHandler } from '../../../utils/api.utils';
import type {
  EvalMetricOption,
  EvalRun,
  StartEvaluationBody,
  StartEvaluationResponse,
} from '../types';

export const getEvaluationMetrics = ServiceHandler<
  unknown,
  { metrics: EvalMetricOption[] }
>({
  url: '/api/chat-agent/v1/evaluation-metrics',
});

export const startEvaluation = ServiceHandler<
  StartEvaluationBody,
  StartEvaluationResponse
>({
  url: '/api/chat-agent/v1/agents/:agentId/evaluations',
  method: 'POST',
});

export const getEvaluation = ServiceHandler<unknown, EvalRun>({
  url: '/api/chat-agent/v1/agents/:agentId/evaluations/:runId',
});

export const listEvaluations = ServiceHandler<unknown, { runs: EvalRun[] }>({
  url: '/api/chat-agent/v1/agents/:agentId/evaluations',
});
